import 'tablesorter/jquery.tablesorter';
import {ResizeObserver} from '@juggle/resize-observer';

import {slyHorizontal} from "../../static/major/js/libs/sly/sly.horizontal";
import {Utils} from "../utils";
import {sortResults} from "./sort-results";

export function setUpBrandTransitions() {
  $('[data-type="brands-all"]:not(.disabled)').on('click', function (e) {
    e.preventDefault();
    $(this).addClass('disabled').attr('disabled', 'disabled');
    $('[data-type="brands-default"]').removeClass('disabled').removeAttr('disabled');
    $('.sly-frame li.active').removeClass('active');
    $('[data-type="popular-brands-info"]').hide();
    $('.brand-summary [data-type="popular-brands"]').hide();
    $('[data-type="initial-alert"]').hide();
    $('.productList li').fadeIn();
    $('.productList-title').find('.model-counter').text('').hide().end().find('.product-name').text('').hide();
  });
}

export function setUpGallery() {
  $('#model-media-gallery .carousel-control').on('click', function (e) {
    e.preventDefault();
    const slide = $(this).data('slide');
    $('#model-media-gallery').carousel(slide);
  });

  $("a.video-player").hide();
  $('a[href^="#video-wrapper"]').on('click', function (e) {
    e.preventDefault();
  });
}

export function setUpDrawer() {
  $('.drawer-knob').on('click', function (e) {
    e.preventDefault();
    const knob = $(this), drawer = knob.siblings('.modelInfo-features');
    drawer.slideToggle();
    knob.toggleClass('active');
  });
  $('.drawer-expand').on('click', function (e) {
    e.preventDefault();
    const expand = $(this);
    if (expand.hasClass('active')) {
      $('.modelInfo-features').slideUp(function () {
        // Workaround for jQuery issue of not sliding up hidden
        // elements. Note that this is not the case for slideDown().
        // See http://bugs.jqueryui.com/ticket/7943
        $(this).hide();
      });
      $('.drawer-knob').removeClass('active');
      expand.html(expand.data('activeText'));
    } else {
      $('.modelInfo-features').slideDown();
      $('.drawer-knob').addClass('active');
      expand.html(expand.data('inactiveText'));
    }
    expand.toggleClass('active inactive');
  });
}

export function setUpTableSorter() {
  // custom parser for Price and Reviews columns
  // to make the empty cell sort work correctly
  $.tablesorter.addParser({
    id: 'customText',
    is: () => false,
    format: (s, t, c, cidx) => $.trim(s) === '0' ? '' : $.trim(s),
    type: 'text'
  });

  $.tablesorter.addParser({
    id: 'tags',
    is: () => false,
    format: (s, t, cell, cidx) => parseInt(s.trim().replace(/[^\d+].*/, '')),
    type: 'numeric'
  });

  $.tablesorter.addParser({
    id: 'reviews',
    is: () => false,
    format: (s, t, cell, cidx) => parseInt(cell.querySelector('.model-rating-score').innerHTML.trim()),
    type: 'numeric'
  });

  $(".table-lines").tablesorter({
    headers: {
      0: {sorter: false},
      3: {sorter: "tags"},
      4: {sorter: "customText"},
      5: {sorter: "reviews"}
    }
  });

  $(".table-active-lines, .table-models").tablesorter({
    // no initial order for this table
    headers: {
      3: {sorter: "customText"},
      4: {sorter: "customText"}
    }
  });

}

export function setUpEvaluationBanner() {
  $('.gb-evaluation-banner.secondary').on('click', function () {
    $(this).find('.collapse').collapse('toggle');
  });

  const banners = $('.gb-collapse-container');
  banners.on('shown.bs.collapse', function () {
    $(this).find('.gb-expand-text').fadeOut();
  });

  banners.on('hidden.bs.collapse', function () {
    $(this).find('.gb-expand-text').fadeIn();
  });

}

export function setUpSly() {
  const models = $('.productList li.modelInfo-container'),
    sortElem = $('#search-results-sort'),
    has_model_info = $('.sly-frame').data('info'),
    model_slice = $('.productList').data('modelSlice'),
    slyFrame = $('.sly-frame');

  const sortModels = () => {
    if (sortElem.length) {
      sortResults(models.filter(':visible'), sortElem.find('option:selected').val());
    }
  };

  initSlyElements(slyFrame, has_model_info, models, sortModels, model_slice);
}


function initSlyElements(slyFrame, has_model_info, models, sortModels, model_slice) {
  if (slyFrame.length) {
    // Setup sly
    const sly = slyHorizontal(slyFrame).data('sly');
    sly.on('active', function () {
      const item = $('.sly-frame li.active'),
        title = item.data('title'),
        slug = item.data('slug'),
        info = item.data('info'),
        djs = Utils.datajs,
        resultsList = $(djs('results-list')),
        showMore = resultsList.find(djs('more-results')).parent();

      $('[data-type="initial-alert"]').hide();
      let children = null;

      if (has_model_info) {
        const _type = item.data('type');
        if (_type === 'brands-default') {
          var popular = models.filter('[data-popular]').show();
          models.not(popular).hide();
          sortModels();
          $('.productList-title .model-counter').text('').hide();
          var prodTitle = $('.productList-title .product-name').data('title');
          $('.productList-title .product-name').text(prodTitle);
          $('.brand-summary li').hide();
          $('[data-type="popular-brands-info"]').hide();
          $('.productList').fadeIn();
          $('.productList-children-title').fadeIn();
          if (resultsList.is(djs('true', 'collapsed')) && resultsList.find('li').length > 3) {
            showMore.show();
          }
          return false;
        }
        showMore.hide();

        const modelCounter = item.data('available-models-count');
        let filtered_models = models.hide().filter('[data-' + _type + '="' + slug + '"]');
        if (model_slice) {
          filtered_models = filtered_models.slice(0, model_slice);
        }
        filtered_models.fadeIn();
        $('.brand-summary [data-type="popular-brands"]:not([data-slug="' + slug + '"])').hide();
        children = $('.brand-summary [data-type="popular-brands"][data-slug="' + slug + '"]');
        children.fadeIn();
        $('.productList-title .product-name').text(title).fadeIn();

        const mc = $('.productList-title .model-counter');
        if (modelCounter) {
          mc.text(modelCounter).fadeIn();
        } else {
          mc.hide();
        }
        $('[data-type="popular-brands-info"]').html(info).fadeIn();
        $('[data-type="brands-all"], [data-type="brands-default"]').removeClass('disabled').removeAttr('disabled');

      } else {
        $('.productList-title .product-name').text(title);

        if (item.data('type') === 'brands-default') {
          $('[data-type="popular-brands"]:not([data-summary])').fadeIn();
          $('[data-type="popular-brands"][data-summary]').hide();
          sortModels();
          $('.productList').fadeIn();
          $('.productList-children-title').fadeIn();
          return false;
        }

        $('[data-type="popular-brands"][data-manufacturer="' + slug + '"][data-slug="' + slug + '"]').fadeIn();
        $('[data-type="popular-brands"]:not([data-manufacturer="' + slug + '"])').hide();
        children = $('[data-type="popular-brands"][data-manufacturer="' + slug + '"]');
        children.fadeIn();
        //$('[data-type="popular-brands-info"]').html(info).fadeIn();
        $('[data-type="popular-brands-info"]').hide();
        $('[data-type="brands-all"], [data-type="brands-default"]').removeClass('disabled').removeAttr('disabled');
      }

      if (!children.not('[data-summary]').length) {
        $('.productList').hide();
        $('.productList-children-title').hide();
      } else {
        $('.productList').fadeIn();
        $('.productList-children-title').fadeIn();
      }
      sortModels();
    });

    window.addEventListener('load', function () {
      // Sometimes Sly doesn't calculate the correct frame width and ends up
      // cutting off some of the items. Reload it after all the images
      // have finished loading.
      sly.reload();
      if (sly.pages.length <= 1) {
        $('.sly-controls').hide();
      } else {
        $('.sly-controls').show();
      }
    });

  }
}

/**
 This code fixes an issue with the "Why it's a Match" section layers titles
 text when they have to wrap on mobile screens.
 **/

const INITIAL_WINDOW_WIDTH = window.innerWidth;
const WRAPPED_CLASS = "wrapped";
const FALLBACK_LINE_HEIGHT = 16;
const MAX_BREAKPOINT = 460;

export const initializeMatchDataTitlesAdjustments = function () {
  const layersTitles = document.querySelectorAll('.match-data__features-item__title');

  Array.from(layersTitles).forEach((title) => {
    const titleText = title.querySelector('.match-data__features-item__title__text');

    if (!titleText.dataset.initialHeight) {
      titleText.dataset.initialHeight = titleText.offsetHeight;
    }
  });

  const adjustTitlesSizeOnWrap = (entries) => {
    for (let index = 0; index < entries.length; index++) {
      const titleText = entries[index].target.querySelector('.match-data__features-item__title__text');
      const {lineHeight} = getComputedStyle(titleText);
      let lineHeightParsed = parseInt(lineHeight.split('px')[0]);

      // We make this check because 'lineHeight' can sometimes return 'normal' instead of a numeric value.
      if (!typeof lineHeightParsed === "number" || isNaN(lineHeightParsed)) lineHeightParsed = FALLBACK_LINE_HEIGHT;

      if (titleText.offsetHeight >= lineHeightParsed * 2) {
        if (!titleText.dataset.breakpoint) titleText.dataset.breakpoint = window.innerWidth;

        titleText.classList.add(WRAPPED_CLASS);
      }

      if (titleText.dataset.breakpoint) {
        const elemBreakpoint = parseInt(titleText.dataset.breakpoint, 10);
        const wrapBreakpoint = elemBreakpoint === INITIAL_WINDOW_WIDTH ? MAX_BREAKPOINT : elemBreakpoint;

        if (window.innerWidth > wrapBreakpoint) {
          titleText.classList.remove(WRAPPED_CLASS);

          if (titleText.offsetHeight >= lineHeightParsed * 2) {
            titleText.classList.add(WRAPPED_CLASS);
          }
        }
      }
    }
  }

  const sizeObserver = new ResizeObserver(adjustTitlesSizeOnWrap)

  layersTitles.forEach((entry) => {
    sizeObserver.observe(entry);
  })
}

// Set up for match data section collapsible items.
export const initializeMatchDataCollapsible = function (e, parent = "") {
  const matchDataCollapseTriggers = $(`${parent} .match-data__collapse-trigger`);
  const IS_OPEN_CLASS = "is_open";
  const INITIALIZED_CLASS = "initialized";

  matchDataCollapseTriggers.each(function () {
    const trigger = $(this);
    const collapsable = trigger.siblings('.match-data__collapse');

    if (!trigger.hasClass(INITIALIZED_CLASS)) {
      trigger.on("click", function () {
        collapsable.slideToggle({
          duration: 400,
          start: function () {
            if (trigger.hasClass(IS_OPEN_CLASS)) trigger.removeClass(IS_OPEN_CLASS);
            else trigger.addClass(IS_OPEN_CLASS);
          },
        })
      })

      collapsable.slideToggle(0)
      trigger.addClass(INITIALIZED_CLASS);
    }
  })
}
